// Prettier: Overwrite via app/.prettierrc.mjs
import { translationsOneway } from './translationsOneway.const'
import { translationsParkingLars } from './translationsParkingLars.const'
import { translationsParkingTilda } from './translationsParkingTilda.const'
import { translationsSeparationTrafficModeMarking } from './translationsSeparationTrafficModeMarking.const'
import { translationsWdith } from './translationsWdith.const'

// Legend:
// - "ALL--" stands for "all sources". Those translations are applied without checking the soureId
// - "ALL--category" is replaced with 'ALL--highway' in `ConditionalFormattedValue`
/* prettier-ignore */
export const translations: { [key: string]: string } = {
  ...translationsParkingLars,
  ...translationsParkingTilda,
  ...translationsOneway,
  ...translationsSeparationTrafficModeMarking,
  ...translationsWdith,
  'ALL--_parent_highway--key': 'Straßentyp Fahrbahn',
  'ALL--category--key': 'Führungsform',
  'ALL--category=bicycleRoad_vehicleDestination': 'Fahrradstraße mit Anlieger/Kfz frei',
  'ALL--category=bicycleRoad': 'Fahrradstraße',
  'ALL--category=crossing': 'Straßenquerung',
  'ALL--category=cycleway_adjoining': 'Radweg (baulich von der Fahrbahn abgesetzt aber straßenbegleitend)',
  'ALL--category=cycleway_adjoiningOrIsolated': 'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'ALL--category=cycleway_crossing': 'Straßenquerung (Radverkehr)',
  'ALL--category=cycleway_isolated': 'Radweg, selbstständig geführt',
  'ALL--category=cyclewayLink': 'Radweg-Verbindungsstück. Häufig in OpenStreetMap verwendet um Routenfähiges Netz zu erzeugen; repräsentiert nur selten physische Infrastruktur.',
  'ALL--category=cyclewayOnHighway_advisory': 'Schutzstreifen',
  'ALL--category=cyclewayOnHighway_advisoryOrExclusive': 'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
  'ALL--category=cyclewayOnHighway_exclusive': 'Radfahrstreifen',
  'ALL--category=cyclewayOnHighwayBetweenLanes': 'Radfahrstreifen in Mittellage (Fahrradweiche)',
  'ALL--category=cyclewayOnHighwayProtected': 'Geschützter Radfahrstreifen (Protected Bike Lane / PBL)',
  'ALL--category=footAndCyclewaySegregated_adjoining': 'Getrennter Rad- und Gehweg, straßenbegleitend',
  'ALL--category=footAndCyclewaySegregated_adjoiningOrIsolated': 'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'ALL--category=footAndCyclewaySegregated_isolated': 'Getrennter Rad- und Gehweg, selbstständig geführt',
  'ALL--category=footAndCyclewayShared_adjoining': 'Gemeinsamer Geh- und Radweg, straßenbegleitend',
  'ALL--category=footAndCyclewayShared_adjoiningOrIsolated': 'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'ALL--category=footAndCyclewayShared_isolated': 'Gemeinsamer Geh- und Radweg, selbstständig geführt',
  'ALL--category=footwayBicycleYes_adjoining': 'Gehweg mit "Radfahrer frei", straßenbegleitend',
  'ALL--category=footwayBicycleYes_adjoiningOrIsolated': 'Gehweg mit "Radfahrer frei" (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
  'ALL--category=footwayBicycleYes_isolated': 'Gehweg mit "Radfahrer frei", selbstständig geführt',
  'ALL--category=livingStreet': 'Verkehrsberuhigter Bereich (Spielstraße)',
  'ALL--category=needsClarification': 'Führungsform unklar. Die Attribute in OpenStreetMap sind nicht ausreichend, um die Führungsform zu kategorisieren. Das deutet darauf hin, dass zusätzlich Attribute in OSM ergänzt werden müssen.',
  'ALL--category=pedestrianAreaBicycleYes': 'Fußgängerzone, Fahrrad frei',
  'ALL--category=separate_geometry': 'RVA als separate Geometrie erfasst',
  'ALL--category=sharedBusLaneBikeWithBus': 'Radfahrstreifen mit Freigabe Busverkehr',
  'ALL--category=sharedBusLaneBusWithBike': 'Bussonderfahrstreifen mit Fahrrad frei',
  'ALL--category=sharedMotorVehicleLane': 'Gemeinsamer Fahrstreifen', // Anteilig genutzten Fahrstreifen
  'ALL--composit_mapillary--key': 'Straßenfotos (Mapillary)',
  'ALL--composit_surface_smoothness--key': 'Oberflächenqualität',
  'ALL--confidence=high': 'Hoch',
  'ALL--confidence=medium': 'Mittel',
  'ALL--covered--key': 'Überdacht',
  'ALL--covered=covered': 'Überdacht',
  'ALL--covered=indoor': 'In einem Gebäude',
  'ALL--description--key': 'Hinweis aus OSM',
  'ALL--highway--key': 'Straßentyp',
  'ALL--highway=bicycle_road': 'Fahrradstraße', // roads--category
  'ALL--highway=construction': 'Straße ist in Bau',
  'ALL--highway=cycleway': 'Radweg',
  'ALL--highway=footway_sidewalk': 'Gehweg',
  'ALL--highway=footway': 'Fußweg',
  'ALL--highway=living_street': 'Verkehrsberuhigter Bereich',
  'ALL--highway=motorway': 'Autobahn',
  'ALL--highway=motorway_link': 'Zufahrt einer Autobahn',
  'ALL--highway=path': 'Weg / Pfad',
  'ALL--highway=pedestrian': 'Fußgängerzone',
  'ALL--highway=primary': 'Bundesstraße/Hauptverbindungsstraße',
  'ALL--highway=primary_link': 'Zufahrt einer Bundesstraße/Hauptverbindungsstraße',
  'ALL--highway=residential': 'Anwohnerstraße',
  'ALL--highway=secondary': 'Landesstraße/Wichtige Durchgangsstraße',
  'ALL--highway=secondary_link': 'Zufahrt einer Landesstraße/wichtigen Durchgangsstraße',
  'ALL--highway=service_alley': 'Gasse', // roads--category
  'ALL--highway=service_driveway': 'Grundstückszufahrt', // roads--category
  'ALL--highway=service_emergency_access': 'Rettungsweg', // roads--category
  'ALL--highway=service_parking_aisle': 'Parkplatzweg', // roads--category
  'ALL--highway=service_road': 'Zufahrtsweg', // roads--category
  'ALL--highway=service_uncategorized': 'Zufahrtsweg (unbekannte Klassifisierung)',
  'ALL--highway=service': 'Zufahrtsweg',
  'ALL--highway=steps': 'Stufen',
  'ALL--highway=tertiary': 'Kreisstraße/Untergeordnete Durchgangsstraße',
  'ALL--highway=tertiary_link': 'Zufahrt einer Kreisstraße/untergeordneten Durchgangsstraße',
  'ALL--highway=track': 'Wald- / Feldweg',
  'ALL--highway=unclassified': 'Nebenstraße mit Verbindungscharakter',
  'ALL--highway=unspecified_road_category': 'Unkategorisierte Straße', // roads--category
  'ALL--informal--key': 'Trampelpfad',
  'ALL--informal=yes': 'Weg als "informeller Weg" erfasst.',
  'ALL--length--key': 'Länge',
  'ALL--length--tooltip': 'Ein berechneter Wert für as OpenStreetMap-Straßensegment. Die Berechnung nutzt die Projektion EPSG:5243 und hat somit eine gute Genaugikeit für Deutschland.',
  'ALL--lifecycle--key': 'Status',
  'ALL--lifecycle=construction': 'In Bau',
  'ALL--lifecycle=construction_no_access': 'Gesperrt aufgrund einer Baustelle',
  'ALL--lifecycle=temporary': 'Temporärer Weg',
  'ALL--maxspeed--key': 'Höchstgeschwindigkeit',
  'ALL--name--key': 'Name',
  'ALL--operator_type--key': 'Betreibertyp',
  'ALL--operator_type=private': 'Privatweg',
  'ALL--operator_type=public': 'Öffentlicher Weg',
  'ALL--smoothness=bad': 'Schlecht',
  'ALL--smoothness=excellent': 'Sehr gut',
  'ALL--smoothness=good': 'Gut',
  'ALL--smoothness=intermediate': 'Mittel gut',
  'ALL--smoothness=very_bad': 'Sehr schlecht',
  'ALL--surface_color--key': 'Oberflächenfarbe',
  'ALL--surface_color=green': 'Grün',
  'ALL--surface_color=no': 'Keine besondere Farbe (explizit)',
  'ALL--surface_color=red': 'Rot',
  'ALL--surface=asphalt': 'Asphalt',
  'ALL--surface=bricks': 'Ziegelsteine',
  'ALL--surface=cobblestone': 'Kopfsteinpflaster',
  'ALL--surface=compacted': 'Verdichtete Deckschicht',
  'ALL--surface=concrete:lanes': 'Betonplatten-Spuren',
  'ALL--surface=concrete:plates': 'Betonplatten',
  'ALL--surface=concrete': 'Beton',
  'ALL--surface=fine_gravel': 'Fester Splitt oder Grand',
  'ALL--surface=grass': 'Gras',
  'ALL--surface=gravel': 'Schotter',
  'ALL--surface=ground': 'Erde/Boden',
  'ALL--surface=large_sett': 'Großsteinpflaster',
  'ALL--surface=metal_grid': 'Metallgitter',
  'ALL--surface=metal': 'Metall',
  'ALL--surface=mosaic_sett': 'Mosaikpflaster',
  'ALL--surface=paved': 'Versiegelte Oberfläche (unspezifisch)',
  'ALL--surface=paving_stones:lanes': 'Verbundpflastersteine-Spuren',
  'ALL--surface=paving_stones': 'Verbundpflastersteine',
  'ALL--surface=pebblestone': 'Kies',
  'ALL--surface=plastic': 'Kunststoff',
  'ALL--surface=rubber': 'Gummi',
  'ALL--surface=sand': 'Sand',
  'ALL--surface=sett': 'Behauenes Steinpflaster (Kopfsteinpflaster)',
  'ALL--surface=small_sett': 'Kleinsteinpflaster',
  'ALL--surface=stone': 'Stein',
  'ALL--surface=unpaved': 'Unbefestigt (unspezifisch)',
  'ALL--surface=wood': 'Holz',
  'ALL--surface=woodchips': 'Holzhackschnitzel',
  'ALL--traffic_sign--key': 'Beschilderung',
  'ALL--traffic_sign:backward--key': 'Beschilderung in Gegenrichtung',
  'ALL--traffic_sign:backward=none': 'Unbeschildert',
  'ALL--traffic_sign:forward--key': 'Beschilderung in Verkehrsrichtung',
  'ALL--traffic_sign:forward=none': 'Unbeschildert',
  'ALL--traffic_sign=none': 'Unbeschildert',
  'ALL--traffic_sign=never': 'Kein Verkehrszeichen erwartet',
  'atlas_aggregated_lengths--title': 'Statistik für radinfra.de',
  'atlas_bicycleParking--capacity--key': 'Anzahl Fahrrad-Stellplätze',
  'atlas_bicycleParking--capacity:cargo_bike--key': 'Anzahl Lastenfahrrad-Stellplätze',
  'atlas_bicycleParking--title': 'Fahrradstellplätze',
  'atlas_bikelanes--category--key': 'Bauliche Führung',
  'ALL--smoothness_source=mtb:scale_to_smoothness': 'Abgeleitet von dem OSM Wert `mtb:scale`',
  'ALL--smoothness_source=parent_highway_tag': 'OSM-Tag `smoothness` der zugeordneten Straße',
  'ALL--smoothness_source=surface_to_smoothness': 'Abgeleitet von dem Wert der Oberfläche über Standard-Werte',
  'ALL--smoothness_source=tag': 'OSM-Tag `smoothness`',
  'ALL--smoothness_source=tracktype_to_smoothness': 'Abgeleitet von dem OSM Wert `tracktype`',
  'ALL--surface_source=parent_highway_tag': 'OSM-Tag `surface` der zugeordneten Straße',
  'ALL--surface_source=tag': 'OSM-Tag `surface`',
  'atlas_bikelanes--title': 'Daten zur Radinfrastruktur',
  'atlas_bikelanesPresence--title': 'Daten zu Radinfrastruktur an Straßen',
  'atlas_bikeroutes--colours--key': 'Farben',
  'atlas_bikeroutes--cycle_highway--key': 'Radschnellverbindung',
  'atlas_bikeroutes--cycle_highway=yes': 'Diese Route repräsentiert eine RSV.',
  'atlas_bikeroutes--cycle_network_key--key': 'Netzwerk-Schlüssel',
  'atlas_bikeroutes--distance--key': 'Angabe Gesamtlänge',
  'atlas_bikeroutes--network_type--key': 'Netzwerkart',
  'atlas_bikeroutes--network_type=basic_network': 'Start-Ziel Route',
  'atlas_bikeroutes--network_type=node_network': 'Teil eines Knotennetzwerks',
  'atlas_bikeroutes--network--key': 'Netzwerkhierarchie',
  'atlas_bikeroutes--network=icn': 'Internationales Radverkehrsnetz (`icn`)',
  'atlas_bikeroutes--network=lcn': 'Lokale Radverkehrsnetze (`lcn`)',
  'atlas_bikeroutes--network=ncn': 'Nationales Radverkehrsnetz (`ncn`)',
  'atlas_bikeroutes--network=rcn': 'Regionale Radverkehrsnetze (`rcn`)',
  'atlas_bikeroutes--operator--key': 'Betreiber/Baulastträger',
  'atlas_bikeroutes--ref--key': 'Referenz',
  'atlas_bikeroutes--roundtrip--key': 'Rundfahrt',
  'atlas_bikeroutes--roundtrip=no': 'Nein',
  'atlas_bikeroutes--roundtrip=yes': 'Ja',
  'atlas_bikeroutes--route_description--key': 'Freitext zur Route',
  'atlas_bikeroutes--symbol_description--key': 'Symbolbeschreibung',
  'atlas_bikeroutes--title': 'Fahrradrouten',
  'atlas_bikeroutes--website--key': 'Website',
  'atlas_bikeroutes--wikipedia--key': 'Wikipedia',
  'atlas_bikeSuitability--bikeSuitability--key': 'Eignung des Wegen für Radverkehr, Radnetze, Radrouten',
  'atlas_bikeSuitability--bikeSuitability=goodSurface': 'Potentiell geeignet aufgrund einer guten Oberfläche.',
  'atlas_bikeSuitability--bikeSuitability=livingStreet': 'Geeignet da Verkehrsberuhigter Bereich (Spielstraße)',
  'atlas_bikeSuitability--bikeSuitability=noMotorizedVehicle': 'Potentiell geeignet aufgrund des Verbots von Kfz.',
  'atlas_bikeSuitability--bikeSuitability=noOvertaking': 'Potentiell geeignet aufgrund des Verkehrszeichens 277.1 – "Verbot des Überholens von einspurigen Fahrzeugen für mehrspurige Kraftfahrzeuge und Krafträdern mit Beiwagen"',
  'atlas_bikeSuitability--title': 'Radeignung',
  'atlas_boundaries--admin_level--key': 'Grenzen Level',
  'atlas_boundaries--admin_level=7': 'Level 7 — Meistens Verwaltungsgemeinschaft, Amt', // https://wiki.openstreetmap.org/wiki/DE:Grenze
  'atlas_boundaries--admin_level=8': 'Level 8 — Meistens (Kreisangehörige) Gemeinde / Stadt',
  'atlas_boundaries--title': 'Grenzen',
  'atlas_landuse--landuse--key': 'Landnutzung',
  'atlas_landuse--landuse=allotments': 'Kleingartenanlage',
  'atlas_landuse--landuse=cemetery': 'Friedhofsgelände',
  'atlas_landuse--landuse=commercial': 'Gewerbliche Nutzung',
  'atlas_landuse--landuse=farmyard': 'Landwirdschaftliche Nutzung',
  'atlas_landuse--landuse=residential': 'Wohngebiet',
  'atlas_landuse--landuse=retail': 'Gewerbliche Nutzung (Einzelhandel/Geschäfte)',
  'atlas_landuse--landuse=school': 'Schulgelände',
  'atlas_landuse--landuse=university': 'Universitätsgelände',
  'atlas_landuse--title': 'Daten zur Landnutzung',
  'atlas_places--place--key': 'Ortskategorie',
  'atlas_places--place=borough': 'Stadtteil/Stadtbezirke',
  'atlas_places--place=city': 'Stadte',
  'atlas_places--place=hamlet': 'Siedlung',
  'atlas_places--place=suburb': 'Stadtteil',
  'atlas_places--place=town': 'Stadt oder große Gemeinde',
  'atlas_places--place=village': 'Dorf',
  'atlas_places--population--key': 'Einwohner:innen-Anzahl',
  'atlas_places--population:date--key': 'Datum der Quelle der Einwohner:innen-Anzahl',
  'atlas_places--title': 'Daten zu Orten',
  'atlas_poiClassification--amenity-fuel': 'Tankstelle',
  'atlas_poiClassification--amenity-pharmacy': 'Apotheke',
  'atlas_poiClassification--amenity-post_office': 'Post',
  'atlas_poiClassification--amenity-townhall': 'Rathaus/Gemeindeamt',
  'atlas_poiClassification--category--key': 'Kategorisierung des POI',
  'atlas_poiClassification--name--key': 'Name POI',
  'atlas_poiClassification--shop-bicycle': 'Fahrradladen',
  'atlas_poiClassification--shop-convenience': 'Minimarkt',
  'atlas_poiClassification--shop-supermarket': 'Supermarkt',
  'atlas_poiClassification--title': 'Daten zu Start-Ziel-Punkten',
  'atlas_poiClassification--tourism-hotel': 'Hotel',
  'atlas_poiClassification--type--key': 'Detail-Kategorie',
  'atlas_poiClassification--type=amenity-bank': 'Bank',
  'atlas_poiClassification--type=amenity-college': 'Weiterführende Schule',
  'atlas_poiClassification--type=amenity-doctors': 'Arzt',
  'atlas_poiClassification--type=amenity-fast_food': 'Imbiss',
  'atlas_poiClassification--type=amenity-kindergarten': 'Kindergarten',
  'atlas_poiClassification--type=amenity-place_of_worship': 'Kirche',
  'atlas_poiClassification--type=amenity-pub': 'Kneipe',
  'atlas_poiClassification--type=amenity-school': 'Schule',
  'atlas_poiClassification--type=amenity-university': 'Universität',
  'atlas_poiClassification--type=tourism-guest_house': 'Unterkunft (B&B)',
  'atlas_poiClassification--type=tourism-museum': 'Museum',
  'atlas_publicTransport--category--key': 'Art',
  'atlas_publicTransport--category=ferry_station': 'Fähranleger',
  'atlas_publicTransport--category=light_rail_station': 'S-Bahn-Station',
  'atlas_publicTransport--category=railway_station': 'Bahnhof regional / überregional',
  'atlas_publicTransport--category=subway_station': 'U-Bahn-Station',
  'atlas_publicTransport--category=tram_station': 'Tramstation',
  'atlas_publicTransport--title': 'ÖPNV-Haltepunkte und Fähranleger',
  'atlas_roads--bikelane_ALL=assumed_no--tooltip': 'Wir erwarten hier keine Infrastruktur. Sollte es eine geben, kann diese natürlich eingetragen werden. Hintergrund: Bei Hauptstraßen wo eine Seite angegeben aber die andere fehlt, treffen wir die Annahme, dass die andere Seite keinen Radweg hat.',
  'atlas_roads--bikelane_ALL=assumed_no': 'Vermutlich vollständig',
  'atlas_roads--bikelane_ALL=data_no': 'Vollständig (explizit "keine")',
  'atlas_roads--bikelane_ALL=data_present': 'Vollständig (explizit)',
  'atlas_roads--bikelane_ALL=missing--tooltip': 'Wir konnten keine Infrastruktur erkennen.',
  'atlas_roads--bikelane_ALL=missing': 'Unvollständig',
  'atlas_roads--bikelane_ALL=not_expected--tooltip': 'Wir erwarten hier keine Infrastruktur.',
  'atlas_roads--bikelane_ALL=not_expected': 'Vermutlich vollständig',
  'atlas_roads--bikelane_title': 'Daten zu Radfinfrastruktur Vollständigkeit der Führungsform',
  'atlas_roads--composit_lit--key': 'Beleuchtung',
  'atlas_roads--composit_maxspeed--key': 'Höchstgeschwindigkeit',
  'atlas_roads--composit_road_bikelanes--key': 'Vollständigkeit RVA',
  'atlas_roads--lit--key': 'Beleuchtung Details',
  'atlas_roads--lit=no': 'Nicht beleuchtet',
  'atlas_roads--lit=special': 'Spezielle Angaben',
  'atlas_roads--lit=yes': 'Beleuchtet',
  'atlas_roads--maxspeed_source--key': 'Höchstgeschwindigkeit Quelle',
  'atlas_roads--maxspeed_source=inferred_from_highway': 'Abgeleitet vom `highway`-Tag.',
  'atlas_roads--maxspeed_source=maxspeed_tag': 'In OSM erfasst über einen `maxspeed`-Kategorie-Tag.',
  'atlas_roads--maxspeed_source=maxspeed': 'In OSM erfasst als Tag `maxspeed`.',
  'atlas_roads--maxspeed_source=zone': 'OSM-Zonen-Tag',
  'atlas_roads--osm_maxspeed:backward': 'Spezielle Höchstgeschwindigkeit gegen die Linienrichtung',
  'atlas_roads--osm_maxspeed:conditional': 'Spezielle Höchstgeschwindigkeit mit Einschränkungen',
  'atlas_roads--osm_maxspeed:forward': 'Spezielle Höchstgeschwindigkeit mit der Linienrichtung',
  'atlas_roads--osm_maxspeed:type--key': 'Höchstgeschwindigkeit Kategorie-Tag',
  'atlas_roads--osm_name--key': 'Name',
  'atlas_roads--osm_source:maxspeed--key': 'Höchstgeschwindigkeit Kategorie-Tag',
  'atlas_roads--osm_zone:maxspeed--key': 'Höchstgeschwindigkeit Kategorie-Tag',
  'atlas_roads--road--key': 'Straßentyp',
  'atlas_roads--smoothness_source=mtb:scale_to_smoothness': 'Abgeleitet von dem OSM Wert `mtb:scale`',
  'atlas_roads--smoothness_source=surface_to_smoothness': 'Abgeleitet von dem Wert der Oberfläche über Standard-Werte',
  'atlas_roads--smoothness_source=tag': 'OSM-Tag `smoothness`',
  'atlas_roads--smoothness_source=tracktype_to_smoothness': 'Abgeleitet von dem OSM Wert `tracktype`',
  'atlas_roads--surface_source=tag': 'OSM-Tag `surface`',
  'atlas_roads--title': 'Daten zur Straße',
  'atlas_roadsPathClasses--title': 'Daten zu Wegen',
  'atlas_todos_lines--title': 'Kampagnen',
  'atlas_trafficSigns--title': 'Beschilderung',
  'mapillary_coverage--title': 'Mapillary Foto',
}
